/*
================================================================ 
     Copyright (c) 2018-2020 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import classes from "./customers.module.css";
import Loader from "../../../component/loader";
import BusApiCall from "../../../helper/axios";
import Button from "../../../component/button";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import CustomerDetails from "../checkout/customerDetails/customerDetails";
import Profile from "../../pm/customer/profile";
import { Grid } from "@mui/material";
import ManageCustomersHierarchy from "./manageCustomersHierarchy";
import Drawer from "@mui/material/Drawer";
import { ChevronLeft } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Card from "@mui/material/Card";
import { UsersIcon } from "../../../component/icons/icons";
import { ButtonGroup } from "@mui/material";
import { DetailView, ListView } from "../../../component/icons/icons";
import UriEncode from "../../../component/uriEncode/uriEncode";
import { withNavigation } from "../../../helper/withNavigation";

// Manage customers parent class
class ManageCustomers extends Component {
  // Declare property values that belongs to the component
  state = {
    customersList: [],
    customersListProxy: [],
    loading: false,
    error: false,
    mode: "add",

    // filter
    searchAccountName: "",
    searchCustomerBAN: "",

    // form data
    showForm: false,
    editForm: false,
    showTable: true,
    isSame: false,
    customerBan: "",
    customerName: "",
    details: {
      ban: "",
      accountName: "",
      partyId: "",
      firstName: "",
      lastName: "",
      officePhone: "",
      mobilePhone: "",
      email: "",
      emailMechId: "",
      mobilePhoneMechId: "",
      officePhoneMechId: "",
      billingCloseDay: "1",
      billing: {
        attention: "",
        phone: "",
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        phoneMechId: "",
        postalMechId: "",
      },
      shipping: {
        attention: "",
        phone: "",
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        phoneMechId: "",
        postalMechId: "",
      },
    },
    rowsPerPage: 20,
    rowsPerPageShow: 0,
    page: 1,
    startRecord: 1,
    sortBy: "customerName",
    sortOrder: "ASC",
    totalCount: 0,
    disableBillingDay: false,
    disableBan: false,
    bread: [],
    customerDetails: {},
    edit: false,

    newAddedAccountName: "",
    modules: {},
    //for profile of customer
    // billingDetails : {},
    // shippingDetails : {},
    // addressDetails:[],
    // paymentMethodList:[],
    // eftAccountList:[],
    // creditCardList:[],
    isMobile: false,
    showCustomerList: false,
    viewMode:
      this.props.router.location.pathname === "/manageLeads" ? "Table" : "Card",
    sectorsList: [],
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    if (this.props.router.location.pathname === "/manageLeads") {
      const storedViewMode = localStorage.getItem("leadViewMode");
      this.setState({
        viewMode: storedViewMode || "Table",
      });
      this.setState({
        bread: [{ title: this.props.t("MANAGE_LEADS"), url: "/manageLeads" }],
      });
    } else {
      this.setState({
        bread: [
          { title: this.props.t("MANAGE_CUSTOMERS"), url: "/manageCustomers" },
        ],
      });
    }
    this.updateIsMobile();
    this.getSectorsList();
    window.addEventListener("resize", this.updateIsMobile);
    this.props.setCompDidMount();
    var modules = JSON.parse(localStorage.getItem("modules"));
    if (modules) {
      this.setState({
        modules,
      });
    }
    // this.getCustomers();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }

  getSectorsList = () => {
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/passthru/GET_LEAD_SECTOR_LIST/endpoint`,
      {},
    )
      .then((res) => {
        var sectors = res.data.sectors;
        if (sectors && sectors.length > 0) {
          sectors.sort((a, b) => a.name.localeCompare(b.name));
          this.setState({
            sectorsList: sectors,
          });
        }
      })
      .catch((err) => {
        // if (err.response && err.response.data && err.response.data.message) {
        //     props.setErrorMessage(err.response.data.message, false)
        // } else {
        //     props.setErrorMessage(props.t('DEFAULT_ERROR_MESSAGE'), false)
        // }
      });
  };
  updateIsMobile = () => {
    const isMobile = window.matchMedia("(max-width: 960px)").matches;
    this.setState({ isMobile });
  };
  // This function is used to get all customers list
  getCustomers = () => {
    this.setState({ loading: true });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/customers?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&customerName=${this.state.customerName}&customerBan=${this.state.customerBan}`,
      {},
      pageOptions,
    )
      .then((res) => {
        this.setState({
          customersList: res.data.customers,
          customersListProxy: res.data.customers,
          loading: false,
          totalCount: +res.headers["x-total-count"],
          disableBillingDay: false,
          disableBan: false,
        });
      })
      .catch((err) => {
        this.setState({ loading: false, totalCount: 0 });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  // This function is used to update filter inputs vallue
  onFilterChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // This function is used to capture enter key event and search data
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterCustomerTable();
    }
  };

  // This function is used to apply filter on customer table data
  filterCustomerTable = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getCustomers();
      },
    );
  };

  // This function is used to clear all filters and show all customers
  clearCustomerTableSearch = () => {
    this.setState(
      {
        customerName: "",
        customerBan: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getCustomers();
      },
    );
  };

  // This function is used to toggle table and add customer view
  showAddCustomer = () => {
    this.setState({
      showForm: true,
    });
  };

  // This function is used to show customer table and reset customer add/edit form
  removeCustomerForm = () => {
    this.setState({
      showForm: false,
      editForm: false,
      showTable: true,
      disableBillingDay: false,
      disableBan: false,
      isSame: false,
      mode: "add",
      customerDetails: {},
    });
  };

  // this function is used to watch change in component properties
  onChange = (e) => {
    let data = { ...this.state.details };
    data[e.target.name] = e.target.value;
    this.setState({
      details: data,
    });
  };

  // Set customer billing data
  setBilling = (e) => {
    let data = { ...this.state.details };
    let billingData = { ...data.billing };
    billingData[e.target.name] = e.target.value;
    data.billing = billingData;
    this.setState({
      details: data,
    });
  };

  // Set customer shipping data
  setShipping = (e) => {
    let data = { ...this.state.details };
    let shippingData = { ...data.shipping };
    shippingData[e.target.name] = e.target.value;
    data.shipping = shippingData;
    this.setState({
      details: data,
    });
  };

  // Check if billing and shipping data is set to be same
  setIsSame = () => {
    this.setState({
      isSame: !this.state.isSame,
    });
  };

  // This function is used to Create new customer
  createCustomer = () => {
    this.setState({
      loading: true,
      showTable: false,
    });
    let data = { ...this.state.details };

    // Set customer ban detail
    let banDetails = {
      accountName: data.accountName,
      ban: data.ban,
      label: data.label,
    };
    // Set customer contact details
    let contact = {
      firstName: data.firstName,
      lastName: data.lastName,
      partyId: data.partyId,
      officePhone: data.officePhone,
      mobilePhone: data.mobilePhone,
      email: data.email,
      emailMechId: data.emailMechId,
      mobilePhoneMechId: data.mobilePhoneMechId,
      officePhoneMechId: data.officePhoneMechId,
      billingCloseDay: data.billingCloseDay,
    };

    // Set customer billing address
    let billing = { ...this.state.details.billing };

    // Set customer shipping address
    let tempShipping = { ...this.state.details.shipping };
    let shipping = this.state.isSame
      ? { ...this.state.details.billing }
      : { ...this.state.details.shipping };
    shipping.phoneMechId = tempShipping.phoneMechId;
    shipping.postalMechId = tempShipping.postalMechId;

    let newData = {
      banDetails: banDetails,
      contact: contact,
      billing: billing,
      shipping: shipping,
    };
    // Create new customer
    BusApiCall("POST", `${constants.busInternalUrl}/customers`, newData)
      .then((res) => {
        this.setState({
          loading: false,
          edit: false,
          showForm: false,
          editForm: false,
          showTable: true,
          disableBillingDay: false,
          disableBan: false,
          mode: "add",
          isSame: false,
        });
        this.removeCustomerForm();
        this.getCustomers();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  // This function is used to check new/update customer data
  addCustomer = (data, notesData, sectorData, RoleData) => {
    this.setState({
      loading: true,
    });
    let contact = {
      ...data,
    };
    contact.custCodeAvailable = data.custCodeAvailable === true ? "Y" : "N";
    delete contact.facilityNamePrefix;
    delete contact.billing;
    delete contact.shipping;
    delete contact.paymentInstrumentsMap;
    delete contact.paymentMethod;
    let banDetails = {
      accountName: data.accountName,
      ban: data.ban,
      partyId: data.partyId,
      label: data.label,
      value: data.ban,
      isManaged: data.isManaged,
      facilityNamePrefix: data.facilityNamePrefix,
    };
    let newData = {
      banDetails: banDetails,
      contact: contact,
      // billing: data.billing,
      shipping: data.shipping,
      // paymentInstrumentsMap: data.paymentInstrumentsMap ? data.paymentInstrumentsMap : null
      paymentInstrumentsMap: null,
    };
    if (newData.shipping.street2) {
    } else {
      newData.shipping.street2 = "";
    }
    if (
      this.state.modules &&
      this.state.modules.module_customer_billing &&
      this.state.modules.module_customer_billing === "enabled"
    ) {
      newData.billing = data.billing;
      if (newData.billing.street2) {
      } else {
        newData.billing.street2 = "";
      }
    } else {
      newData.billing = {
        attention: "",
        phone: "",
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      };
    }
    if (window.location.pathname === "/manageLeads") {
      newData.lead = {
        isLead: "Y",
      };
    }
    // return;
    BusApiCall("POST", `${constants.busInternalUrl}/customers`, newData)
      .then((res) => {
        console.log("check customer response", res);
        if (window.location.pathname === "/manageLeads") {
          Promise.all([
            BusApiCall(
              "POST",
              `${constants.busV44UrlPublic}/customers/${UriEncode(res.data.customer.ban)}/notes`,
              notesData,
            ),
            BusApiCall(
              "POST",
              `${constants.busV44UrlPublic}/party/${res.data.customer.partyId}/attributes`,
              sectorData,
            ),
            BusApiCall(
              "POST",
              `${constants.busV44UrlPublic}/party/${res.data.customer.partyId}/attributes`,
              RoleData,
            ),
          ]).then((optionalRes) => {
            console.log("check optional res", optionalRes);
          });
        } else {
          this.setState({
            newAddedAccountName: data.accountName,
          });
        }
        if (data.paymentInstrumentsMap) {
          let paymentData = {
            contact: {
              firstName: newData.contact.firstName,
              lastName: newData.contact.lastName,
              partyId: res.data.customer.partyId,
              officePhone: newData.contact.officePhone,
              mobilePhone: newData.contact.mobilePhone,
              email: newData.contact.email,
              emailMechId: res.data.customer.emailMechId,
              mobilePhoneMechId: res.data.customer.mobilePhoneMechId,
              officePhoneMechId: res.data.customer.officePhoneMechId,
              billingCloseDay: newData.contact.billingCloseDay,
            },
            billing: {
              attention: "",
              phone: "",
              street1: "",
              street2: "",
              city: "",
              state: "",
              zip: "",
              country: "",
            },
            shipping: {
              attention: "",
              phone: "",
              street1: "",
              street2: "",
              city: "",
              state: "",
              zip: "",
              country: "",
            },
            banDetails: {
              accountName: data.accountName,
              ban: data.ban,
              isManaged: data.isManaged,
            },
          };
          if (data.paymentInstrumentsMap.creditCard) {
            let cardData = data.paymentInstrumentsMap.creditCard;
            let creditCard = {
              cardType: cardData.cardType,
              isPrimary: cardData.isPrimary,
              cardNumber: cardData.cardNumber,
              expireDate: cardData.expireDate,
              nameOnCard:
                cardData.firstNameOnCard + " " + cardData.lastNameOnCard,
              ...data.billing,
              billingContactMechId: res.data.customer.billing.postalMechId,
            };
            let payment = {
              creditCard: creditCard,
            };
            paymentData.paymentInstrumentsMap = payment;
          } else if (data.paymentInstrumentsMap.eftAccount) {
            let eftAccount = {
              ...data.paymentInstrumentsMap.eftAccount,
              ...data.billing,
              billingContactMechId: res.data.customer.billing.postalMechId,
            };
            let payment = {
              eftAccount: eftAccount,
            };
            paymentData.paymentInstrumentsMap = payment;
          }
          BusApiCall(
            "POST",
            `${constants.busInternalUrl}/customers`,
            paymentData,
          )
            .then((res) => {
              this.setState({
                loading: false,
                edit: false,
                showForm: false,
                editForm: false,
                showTable: true,
                disableBillingDay: false,
                disableBan: false,
                mode: "add",
                isSame: false,
                customerDetails: {},
              });
              let customer = {
                accountName: newData.banDetails.accountName,
              };
              if (window.location.pathname.includes("/manageLeads")) {
                this.props.setErrorMessage(
                  this.props.t("LEAD_CREATED_SUCCESSFULLY", { customer }),
                  true,
                );
              } else {
                this.props.setErrorMessage(
                  this.props.t("CUSTOMER_CREATED_SUCCESSFULLY", { customer }),
                  true,
                );
              }
              this.removeCustomerForm();
              this.getCustomers();
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.props.setErrorMessage(err.response.data.message, false);
              } else {
                this.props.setErrorMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  false,
                );
              }
              this.setState({
                loading: false,
              });
            });
        } else {
          this.setState({
            loading: false,
            edit: false,
            showForm: false,
            editForm: false,
            showTable: true,
            disableBillingDay: false,
            disableBan: false,
            mode: "add",
            isSame: false,
            customerDetails: {},
          });
          let customer = {
            accountName: newData.banDetails.accountName,
          };
          if (window.location.pathname.includes("/manageLeads")) {
            this.props.setErrorMessage(
              this.props.t("LEAD_CREATED_SUCCESSFULLY", { customer }),
              true,
            );
          } else {
            this.props.setErrorMessage(
              this.props.t("CUSTOMER_CREATED_SUCCESSFULLY", { customer }),
              true,
            );
          }
          this.removeCustomerForm();
          this.getCustomers();
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  // This function is used to create update customer data and set in form
  editCustomer = (data, i) => {
    this.setState({
      customerDetails: data,
      editForm: true,
      showForm: true,
      showTable: false,
      mode: "edit",
      // bread: [{ title: this.props.t("MANAGE_CUSTOMER", { data }), url: "" }],
    });
  };

  // Close error message
  closeErrorMessage = () => {
    this.props.setErrorMessage("", false);
  };

  // Validate BAN no on blur
  validateBanOnBlur = () => {
    const { t } = this.props;
    this.closeErrorMessage("", false);
    if (this.state.mode === "add") {
      if (this.state.details.ban.length > 20) {
        this.props.setErrorMessage(
          t("CUSTOMER_BAN_VALIDATION_ERROR_MESSAGE"),
          false,
        );
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  // Validate customer form basic details
  validateForm = () => {
    for (let key in this.state.details) {
      if (
        key === "ban" ||
        key === "accountName" ||
        key === "email" ||
        key === "firstName" ||
        key === "lastName" ||
        key === "officePhone"
      ) {
        if (!this.state.details[key]) {
          return false;
        }
      }
    }
    return true;
  };
  // Validate customer form address (Billing, Shipping)
  validateAddress = (data) => {
    for (let key in data) {
      if (
        key === "attention" ||
        key === "city" ||
        key === "country" ||
        key === "state" ||
        key === "street1" ||
        key === "zip"
      ) {
        if (!data[key]) {
          return false;
        }
      }
    }
    return true;
  };

  // Validate phone numbers
  validatePhoneNo = (val) => {
    if (val) {
      var pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      return pattern.test(val);
    }
    return true;
  };

  // Change customer table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getCustomers();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getCustomers();
        },
      );
    }
  };

  // Change customer table page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getCustomers();
      },
    );
  };

  // Change rows per page to show
  handleChangeRowsPerPage = (event) => {
    let val = 0;
    if (event.target.value === 0) {
      val = 20;
    } else if (event.target.value === 1) {
      val = 50;
    } else {
      val = 100;
    }
    this.setState(
      {
        page: 1,
        rowsPerPage: val,
        rowsPerPageShow: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getCustomers();
      },
    );
  };

  closeErrorMessage = (error, type) => {
    this.props.setErrorMessage(error, type);
  };

  changeRoute = (data) => {
    console.log("check pros data", this.props);
    // this.props.router.navigate({
    //     pathname: '/newOrder',
    //     state: data
    // })
  };

  createLeadQuote = (e, data) => {
    this.props.router.navigate("/newOrder", {
      state: {
        leadData: data,
        leadQuote: true,
      },
    });
  };


  toggleShowCustomerList = () => {
    this.setState((prevState) => ({
      showCustomerList: !prevState.showCustomerList,
    }));
  };

  toggleViewMode = () => {
    const { viewMode } = this.state;
    const newViewMode = viewMode === "Card" ? "Table" : "Card";
    this.setState({
      viewMode: newViewMode,
    });
    if (this.props.router.location.pathname === "/manageLeads") {
      localStorage.setItem("leadViewMode", newViewMode);
    }
  };

  render() {
    const { t } = this.props;
    const { isMobile, showCustomerList } = this.state;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid item size={{ xs: 12, md: 6 }}>
                <h3 className={"customBreadcrumb"}>
                  {this.state.editForm ? (
                    <span
                      onClick={() => {
                        this.removeCustomerForm();
                      }}
                      style={{ color: this.props.tenantData.color }}
                    >
                      {this.props.router.location.pathname === "/manageLeads"
                        ? t("MANAGE_LEADS")
                        : t("MANAGE_CUSTOMERS")}
                      {/* {t("MANAGE_CUSTOMERS")} */}
                    </span>
                  ) : (
                    <label style={{ color: this.props.tenantData.color }}>
                      {this.state.showForm && !this.state.editForm ? (
                        <>
                          <u
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.setState({
                                showForm: !this.state.showForm,
                                showTable: true,
                              });
                            }}
                          >
                            {this.props.router.location.pathname ===
                              "/manageLeads"
                              ? t("MANAGE_LEADS")
                              : t("MANAGE_CUSTOMERS")}
                            {/* {t("MANAGE_CUSTOMERS")} */}
                          </u>{" "}
                          <span style={{ margin: "0 8px" }}>{">"}</span>{" "}
                          <b>{t("NEW_CUSTOMER")}</b>
                        </>
                      ) : (
                        // <b>{t("MANAGE_CUSTOMERS")}</b>
                        <b>
                          {this.props.router.location.pathname ===
                            "/manageLeads"
                            ? t("MANAGE_LEADS")
                            : t("MANAGE_CUSTOMERS")}
                        </b>
                      )}
                    </label>
                  )}
                  {this.state.editForm ? " > " : ""}
                  <b>
                    {this.state.editForm &&
                      this.state.customerDetails.accountName}
                  </b>
                </h3>
              </Grid>
              {/* {isMobile && (
								<Grid item xs={6} style={{ textAlign: "right" }}>
									<Button className="buttonSecondary" onClick={this.toggleShowCustomerList}>
										<span style={{ marginRight: ".25rem", verticalAlign: "middle" }}>
											<UsersIcon />
										</span>
										{t("SHOW_CUSTOMER_LIST")}
									</Button>
								</Grid>
							)} */}
              <Grid
                item
                size={{ xs: 12, md: 6 }}
                style={{
                  textAlign: "right",
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "flex-end",
                }}
              >
                {isMobile && (
                  <Button
                    className="buttonSecondary"
                    onClick={this.toggleShowCustomerList}
                  >
                    <span
                      style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                    >
                      <UsersIcon />
                    </span>
                    {t("SHOW_CUSTOMER_LIST")}
                  </Button>
                )}
                {/* {this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" && */}
                {this.props.permissions.includes("PARTYMGR_ADMIN") &&
                  !(
                    this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                    this.props.loggedInUserType === "ECOMMERCE_ADMIN"
                  ) &&
                  this.props.providerType === "SALES_CHNL_PROVIDER" && (
                    <>
                      {!this.state.showForm && (
                        <>
                          <Button
                            onClick={() => {
                              this.setState({
                                showForm: !this.state.showForm,
                                showTable: false,
                              });
                            }}
                          >
                            <span
                              style={{
                                marginRight: ".25rem",
                                verticalAlign: "middle",
                              }}
                            >
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {this.props.router.location.pathname ===
                              "/manageLeads"
                              ? t("NEW_LEAD")
                              : t("ADD_CUSTOMER")}
                          </Button>
                        </>
                      )}
                    </>
                  )}
              </Grid>
            </Grid>
          </div>
        </div>
        <main style={{ padding: this.state.showTable ? "auto" : "25px 35px" }}>
          {!this.state.showForm &&
            this.props.router.location.pathname === "/manageLeads" && (
              <Grid container spacing={2} style={{ marginBottom: ".5rem" }}>
                <Grid
                  item
                  size={{ xs: 12 }}
                  style={{ justifyContent: "flex-end", display: "flex" }}
                >
                  <ButtonGroup variant="outlined">
                    {/* DETAIL VIEW button */}
                    <span
                      className={`buttonGroup ${this.state.viewMode === "Card" ? "selected" : ""}`}
                      onClick={this.toggleViewMode}
                      style={{
                        backgroundColor:
                          this.state.viewMode === "Card"
                            ? this.props.tenantData.color
                            : "inherit",
                        color:
                          this.state.viewMode === "Card" ? "white" : "inherit",
                      }}
                    >
                      <span style={{ marginRight: ".4rem" }}>
                        {this.props.t("CARD_VIEW")}
                      </span>
                      <DetailView />
                    </span>
                    {/* LIST VIEW button */}
                    <span
                      className={`buttonGroup ${this.state.viewMode === "Table" ? "selected" : ""}`}
                      onClick={this.toggleViewMode}
                      style={{
                        backgroundColor:
                          this.state.viewMode === "Table"
                            ? this.props.tenantData.color
                            : "inherit",
                        color:
                          this.state.viewMode === "Table" ? "white" : "inherit",
                      }}
                    >
                      <span>{this.props.t("LIST_VIEW")}</span>
                      <ListView />
                    </span>
                  </ButtonGroup>
                </Grid>
              </Grid>
            )}
          {/* <Breadcrumb list={this.state.bread} /> */}
          {/* <div style={{ position: 'relative' }}>
                        <h3 className={'customBreadcrumb'}>
                            {this.state.editForm ?
                                <span onClick={() => { this.removeCustomerForm() }} style={{ color: this.props.tenantData.color }}>Manage Customer</span>
                                :
                                <label style={{ color: this.props.tenantData.color }}>
                                    {this.state.showForm && !this.state.editForm ? t('ADD_NEW_CUSTOMER') : t('MANAGE_CUSTOMERS')}
                                </label>
                            }
                            {this.state.editForm ? ' > ' : ''}
                            {this.state.editForm && this.state.customerDetails.accountName}
                        </h3>
                        <div className={classes.addOuterDiv}>
                            {this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                                <>
                                    {!this.state.showForm &&
                                        <Button onClick={() => { this.setState({ showForm: !this.state.showForm, showTable: false }) }}>{t('ADD_CUSTOMER')}</Button>
                                    }
                                </>
                            }
                        </div>
                    </div> */}
          {/* Add new customer block */}
          {this.state.showForm && !this.state.editForm && (
            <div>
              <CustomerDetails
                manageCustomer={true}
                close={this.removeCustomerForm}
                addCustomer={this.addCustomer}
                validator={this.closeErrorMessage}
                customerDetails={this.state.customerDetails}
                screenType={
                  this.props.router.location.pathname === "/manageLeads"
                    ? "leads"
                    : "customer"
                }
                sectorsList={this.state.sectorsList}
              />
            </div>
          )}
          {/* Update customer block */}
          {this.state.editForm && (
            <div>
              <Profile
                screen="manageCustomer"
                customerDetails={this.state.customerDetails}
              />
            </div>
          )}
          {/* Costumers table block */}
          {this.state.showTable && (
            <>
              <div>
                {/* <ManageCustomersHierarchy
                                    screen="manageCustomer"
                                    newAddedAccountName={this.state.newAddedAccountName}
                                /> */}
                <ManageCustomersHierarchy
                  screen="manageCustomer"
                  newAddedAccountName={this.state.newAddedAccountName}
                  changeRoute={this.changeRoute}
                  isMobile={this.state.isMobile}
                  showCustomerList={this.state.showCustomerList}
                  toggleShowCustomerList={this.toggleShowCustomerList}
                  screenType={
                    this.props.router.location.pathname === "/manageLeads"
                      ? "leads"
                      : "customer"
                  }
                  viewMode={this.state.viewMode}
                  sectorsList={this.state.sectorsList}
                  createLeadQuote={this.createLeadQuote}
                />
              </div>
            </>
          )}
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
    permissions: state.auth.userPerms,
    countriesList: state.global.countriesList,
    providerType: state.auth.providerType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(ManageCustomers)));
